<template>
    <div class="block rounded-24 overflow-hidden">
        <div class="row justify-content-center py-3">
            <div class="" id="faqs-container">
                <FAQItem
                    v-for="(faq, index) in faqs"
                    :key="index"
                    :faq="faq"
                    :index="index"
                    @remove="removeFAQ"
                    @moveUp="moveUp"
                    @moveDown="moveDown"
                />
            </div>
        </div>
        <div class="d-flex justify-content-end mt-1">
            <button type="button" class="btn_pluss btn-primary my-2 mx-2 text-white rounded-circle pt-1" @click="addFAQ">
                +
            </button>
        </div>
    </div>
</template>

<script>
import FAQItem from './FAQItem.vue'

export default {
    components: { FAQItem },
    props: {
        faqs: {
            type: Array,
            required: true,
        },
    },
    methods: {
        addFAQ() {
            this.$emit('add-faq')
        },
        removeFAQ(index) {
            this.$emit('remove-faq', index)
        },
        moveUp(index) {
            this.$emit('move-up-faq', index)
        },
        moveDown(index) {
            this.$emit('move-down', index)
        },
    },
}
</script>

<style></style>
